type SanityImage = {
  alt?: string | null;
  assetId?: string | null;
  url?: string | null;
} | null | undefined;

export function sanityImageUrl(
  image: SanityImage,
  opts: { width?: number; quality?: number } = {},
): string | null {
  if (!image?.url) return null;
  const params = new URLSearchParams();
  if (opts.width) params.set("w", String(opts.width));
  if (opts.quality) params.set("q", String(opts.quality));
  params.set("auto", "format");
  params.set("fit", "max");
  const query = params.toString();
  return query ? `${image.url}?${query}` : image.url;
}
